import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class EdpRecaptchaService {
    private edpRecaptchaSubject = new BehaviorSubject<string>(null);

    setContactResponse(edpRecaptcha: string) {
        this.edpRecaptchaSubject.next(edpRecaptcha);
    }

    getContactResponse() {
        return this.edpRecaptchaSubject.value;
    }
}
